import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGlobe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGlobe"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 21.5C9.79086 21.5 8 17.2467 8 12C8 6.75329 9.79086 2.5 12 2.5C14.2091 2.5 16 6.75329 16 12C16 17.2467 14.2091 21.5 12 21.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M21 12H3" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGlobe;
